const INITIALIZE = "app/INITIALIZE";
const NAV_COUNT = "app/NAV_COUNT";
const DIMENSIONS = "app/DIMENSIONS";
export { INITIALIZE, NAV_COUNT, DIMENSIONS };
